import React from 'react';
import { Text, Title } from 'components';

interface ReplaceAgreementTextProps {
  isRestore?: boolean;
}

const ReplaceAgreementText: React.FC<ReplaceAgreementTextProps> = ({
  isRestore,
}) => {
  let description =
    'Replacing it will archive any older versions of this document and submit it for review by your brokerage admin.';
  if (isRestore) {
    description =
      'Restoring this file will replace the active file and revert this listing back to pending status for review.';
  }
  return (
    <div>
      <Title level={4}>
        Do you want to replace the current Listing Paperwork?
      </Title>
      <Text block type="secondary">
        {description}
      </Text>
    </div>
  );
};

export default ReplaceAgreementText;
